<div class="w-full h-full overflow-hidden grid grid-cols-3 gap-4">

    <article
        class="col-span-1 divide-y divide-zinc-200 dark:divide-zinc-600 overflow-hidden rounded-lg bg-white dark:bg-gray-800 shadow">
        <div class="px-2 py-3">
            <div class="flex items-center gap-2 text-emerald-700 dark:text-emerald-400">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-trending-up-icon lucide-trending-up size-5">
                    <path d="M16 7h6v6" />
                    <path d="m22 7-8.5 8.5-5-5L2 17" />
                </svg>
                <h3 class="text-sm font-semibold text-emerald-700 dark:text-emerald-400">Highest Engagement</h3>
            </div>

            <p class="mt-1 text-xs text-secondary">Creator with the highest engagement rate</p>
        </div>

        <div class="px-2 py-3 flex flex-col gap-y-4">
            @if (engagementPerformers() && engagementPerformers()!.length > 0) {
            @for (performer of engagementPerformers(); track $index) {
            <div class="border-0 bg-gradient-to-r from-emerald-50 to-teal-50 dark:from-emerald-900/30 dark:to-teal-900/30 border-emerald-100 dark:border-emerald-800 rounded-xl p-2">
                <div class="flex justify-between">
                    <div class="flex items-center gap-3">
                        <img [src]="imageService.getImageSource(performer.profilePic, 'gallery')" alt="Alex Chen"
                            class="w-12 h-12 rounded-full" />
                        <div>
                            <p class="font-semibold text-emerald-900 dark:text-emerald-300">{{ performer.handle }}</p>
                            <div class="flex flex-row items-center gap-x-2 text-emerald-700 dark:text-emerald-300">
                                <span
                                    class="inline-flex items-center gap-x-1.5 rounded-full px-2 py-1 text-xs font-medium text-emerald-700 dark:text-emerald-300 ring-1 ring-inset ring-emerald-200 dark:ring-emerald-700/50">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="lucide lucide-message-square-heart-icon lucide-message-square-heart size-4 text-emerald-700 dark:text-emerald-300">
                                        <path
                                            d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z" />
                                        <path
                                            d="M7.5 9.5c0 .687.265 1.383.697 1.844l3.009 3.264a1.14 1.14 0 0 0 .407.314 1 1 0 0 0 .783-.004 1.14 1.14 0 0 0 .398-.31l3.008-3.264A2.77 2.77 0 0 0 16.5 9.5 2.5 2.5 0 0 0 12 8a2.5 2.5 0 0 0-4.5 1.5" />
                                    </svg>
                                    {{ performer.engagementRate }}%
                                </span>

                                <span
                                    class="inline-flex items-center gap-x-1.5 rounded-full px-2 py-1 text-xs font-medium text-emerald-700 dark:text-emerald-300 ring-1 ring-inset ring-emerald-200 dark:ring-emerald-700/50">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="lucide lucide-message-square-heart-icon lucide-message-square-heart size-4 text-emerald-700 dark:text-emerald-300">
                                        <path
                                            d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" />
                                        <circle cx="12" cy="12" r="3" />
                                    </svg>
                                    {{ formatService.convertIntToString(performer.views) }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-row items-center gap-x-2">
                        <button type="button" (click)="openPostInNewTab(performer.videoLink)" class="justify-end text-gray-900 dark:text-gray-100 hover:cursor-pointer">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" class="size-5 text-gray-700 dark:text-gray-300">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                            </svg>
                        </button>

                        <button type="button" (click)="launchContentViewer(performer)" class="justify-end text-gray-900 dark:text-gray-100 hover:cursor-pointer">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                class="size-5 text-gray-700 dark:text-gray-300">
                                <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
                                <path fill-rule="evenodd"
                                    d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 0 1 0-1.113ZM17.25 12a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0Z"
                                    clip-rule="evenodd" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            }
            }
        </div>
    </article>


    <article
        class="col-span-1 divide-y divide-zinc-200 dark:divide-zinc-600 overflow-hidden rounded-lg bg-white dark:bg-gray-800 shadow">
        <div class="px-2 py-3">
            <div class="flex items-center gap-2 text-blue-700 dark:text-blue-400">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-trending-up-icon lucide-trending-up size-5">
                    <path d="M16 7h6v6" />
                    <path d="m22 7-8.5 8.5-5-5L2 17" />
                </svg>
                <h3 class="text-sm font-semibold text-blue-700 dark:text-blue-400">Most Viewed</h3>
            </div>

            <p class="mt-1 text-xs text-secondary">Creator with the highest views</p>
        </div>

        <div class="px-2 py-3 flex flex-col gap-y-4">
            @if (viewedPerformers() && viewedPerformers()!.length > 0) {
            @for (performer of viewedPerformers(); track $index) {
                <div class="border-0 bg-gradient-to-r from-blue-50 to-sky-50 dark:from-blue-900/30 dark:to-sky-900/30 border-blue-100 dark:border-blue-800 rounded-xl p-2">
                <div class="flex justify-between">
                    <div class="flex items-center gap-3">
                        <img [src]="imageService.getImageSource(performer.profilePic, 'gallery')" alt="Alex Chen"
                            class="w-12 h-12 rounded-full" />
                        <div>
                            <p class="font-semibold text-blue-900 dark:text-blue-300">{{ performer.handle }}</p>
                            <div class="flex flex-row items-center gap-x-2 text-blue-700 dark:text-blue-300">
                                <span
                                    class="inline-flex items-center gap-x-1.5 rounded-full px-2 py-1 text-xs font-medium text-blue-700 dark:text-blue-300 ring-1 ring-inset ring-blue-200 dark:ring-blue-700/50">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="lucide lucide-message-square-heart-icon lucide-message-square-heart size-4 text-blue-700 dark:text-blue-300">
                                        <path
                                            d="M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z" />
                                        <path
                                            d="M7.5 9.5c0 .687.265 1.383.697 1.844l3.009 3.264a1.14 1.14 0 0 0 .407.314 1 1 0 0 0 .783-.004 1.14 1.14 0 0 0 .398-.31l3.008-3.264A2.77 2.77 0 0 0 16.5 9.5 2.5 2.5 0 0 0 12 8a2.5 2.5 0 0 0-4.5 1.5" />
                                    </svg>
                                    {{ performer.engagementRate }}%
                                </span>

                                <span
                                    class="inline-flex items-center gap-x-1.5 rounded-full px-2 py-1 text-xs font-medium text-blue-700 dark:text-blue-300 ring-1 ring-inset ring-blue-200 dark:ring-blue-700/50">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="lucide lucide-message-square-heart-icon lucide-message-square-heart size-4 text-blue-700 dark:text-blue-300">
                                        <path
                                            d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" />
                                        <circle cx="12" cy="12" r="3" />
                                    </svg>
                                    {{ formatService.convertIntToString(performer.views) }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-row items-center gap-x-2">
                        <button type="button" (click)="openPostInNewTab(performer.videoLink)" class="justify-end text-gray-900 dark:text-gray-100 hover:cursor-pointer">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" class="size-5 text-gray-700 dark:text-gray-300">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                            </svg>
                        </button>

                        <button type="button" (click)="launchContentViewer(performer)" class="justify-end text-gray-900 dark:text-gray-100 hover:cursor-pointer">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                class="size-5 text-gray-700 dark:text-gray-300">
                                <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
                                <path fill-rule="evenodd"
                                    d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 0 1 0-1.113ZM17.25 12a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0Z"
                                    clip-rule="evenodd" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            }
            }
        </div>
    </article>


    <article
        class="col-span-1 divide-y divide-zinc-200 dark:divide-zinc-600 overflow-hidden rounded-lg bg-white dark:bg-gray-800 shadow">
        <div class="px-2 py-3">
            <div class="flex items-center gap-2 text-accent">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="lucide lucide-trending-up-icon lucide-trending-up size-5">
                    <path d="M16 7h6v6" />
                    <path d="m22 7-8.5 8.5-5-5L2 17" />
                </svg>
                <h3 class="text-sm font-semibold text-accent">Most Liked</h3>
            </div>

            <p class="mt-1 text-xs text-secondary">Creator with the most likes</p>
        </div>

        <div class="px-2 py-3 flex flex-col gap-y-4">
            @if (likedPerformers() && likedPerformers()!.length > 0) {
            @for (performer of likedPerformers(); track $index) {
            <div class="border-0 bg-gradient-to-r from-primary/10 to-brand-studio/15 dark:from-primary/20 dark:to-brand-studio/20 border-primary/15 dark:border-primary/35 rounded-xl p-2">
                <div class="flex justify-between">
                    <div class="flex items-center gap-3">
                        <img [src]="imageService.getImageSource(performer.profilePic, 'gallery')" alt="Alex Chen"
                            class="w-12 h-12 rounded-full" />
                        <div>
                            <p class="font-semibold text-foreground">{{ performer.handle }}</p>
                            <div class="flex flex-row items-center gap-x-2 text-accent">
                                <span
                                    class="inline-flex items-center gap-x-1.5 rounded-full px-2 py-1 text-xs font-medium text-accent ring-1 ring-inset ring-primary/25 dark:ring-primary/40">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="lucide lucide-message-square-heart-icon lucide-message-square-heart size-4 text-accent">
                                        <path
                                            d="M2 9.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5c0 2.29-1.5 4-3 5.5l-5.492 5.313a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5" />
                                    </svg>
                                    {{ performer.likes }}
                                </span>

                                <span
                                    class="inline-flex items-center gap-x-1.5 rounded-full px-2 py-1 text-xs font-medium text-accent ring-1 ring-inset ring-primary/25 dark:ring-primary/40">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="lucide lucide-message-square-heart-icon lucide-message-square-heart size-4 text-accent">
                                        <path
                                            d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" />
                                        <circle cx="12" cy="12" r="3" />
                                    </svg>
                                    {{ formatService.convertIntToString(performer.views) }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-row items-center gap-x-2">
                        <button type="button" (click)="openPostInNewTab(performer.videoLink)" class="justify-end text-gray-900 dark:text-gray-100 hover:cursor-pointer">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" class="size-5 text-gray-700 dark:text-gray-300">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
                            </svg>
                        </button>

                        <button type="button" (click)="launchContentViewer(performer)" class="justify-end text-gray-900 dark:text-gray-100 hover:cursor-pointer">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                class="size-5 text-gray-700 dark:text-gray-300">
                                <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
                                <path fill-rule="evenodd"
                                    d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 0 1 0-1.113ZM17.25 12a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0Z"
                                    clip-rule="evenodd" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            }
            }
        </div>
    </article>
</div>